// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3dWbu","errorLogs":"styles_errorLogs__wAzmD"};